const fn = parent.window['Grasp'].fn;
export default {
    deactivate() {
        fn.deactivate();
    },
    detectBrowser() {
        return fn.detectBrowser();
    },
    toggleFrameSize() {
        fn.toggleFrameSize();
        fn.setHook('toggle-frame-size');
    },
    updateUnreadsCount(cnt) {
        return fn.updateUnreadsCount(cnt);
    },
    setMessengerInitialised() {
        fn.setHook('initialised-messenger');
    },
    setMessengerLoaded() {
        fn.setHook('loaded-messenger');
    },
    isInPreviewMode() {
        return fn.isInPreviewMode();
    },
    isMessengerOpened() {
        return fn.isOpened();
    },
    isWindowFocused() {
        return fn.isWindowFocused();
    },
    isMobile() {
        return fn.isMobile();
    },
    getRemoteHostInfo() {
        return fn.getRemoteHostInfo();
    },
    getPersistedSettings() {
        return fn.getPersistedSettings();
    },
    getApiKey() {
        return fn.getApiKey();
    },
    getSessionData() {
        return fn.getSessionData();
    },
    openUrl(url, target) {
        fn.openUrl(url, target || null);
    },
    setDocumentTitle(title, timeoutInMs) {
        fn.setDocumentTitle(title, timeoutInMs);
    },
    saveSessionData(data) {
        return fn.saveSessionData(data);
    },
    setRemoteSettings(data) {
        fn.setRemoteSettings(data);
    },
    showMedia(url, tp) {
        fn.showMedia(url, tp);
    },
    closeMessenger() {
        return fn.closeMessenger();
    },
    openMessenger() {
        return fn.openMessenger();
    },
    changeView(name, params) {
        return fn.changeView(name, params || null);
    },
    changeLocale(locale) {
        return fn.changeLocale(locale);
    },
    changeTheme(theme) {
        return fn.changeTheme(theme);
    },
    isGdprApproved() {
        return fn.isGdprApproved();
    },
    approveGDPR(b = true) {
        return fn.approveGDPR(b);
    },
    setMessengerHeight(lvl) {
        fn.setMessengerHeight(lvl);
    },
    getInitialAction() {
        return fn.getInitialAction();
    },
    showAlert(title, body, duration = 0) {
        fn.showAlert(title, body, duration);
    },
    /**
     * set messenger mode (normal, floating)
     * @param mode
     */
    getLaunchIconVisibility() {
        return fn.getLaunchIconVisibility();
    },
    setMessengerMode(mode) {
        fn.setMessengerMode(mode);
    }
};
